import type { PostHog } from "posthog-js";
import type { PosthogBootstrap } from "~/.server/posthog";

export function synchronizePosthogIdentity(
  client: Pick<PostHog, "get_property" | "get_distinct_id" | "reset" | "register" | "identify" | "updateFlags" | "reloadFeatureFlags">,
  bootstrap: PosthogBootstrap,
) {
  const persistedAuthID = client.get_property("$user_id");
  const accountChanged = !!persistedAuthID && persistedAuthID !== bootstrap.authID;
  if (accountChanged) {
    client.reset(true);
  }
  if (!persistedAuthID || accountChanged) {
    // Match the fresh server cookie so anonymous SSR flags and browser events
    // retain the same assignment after logout or an account switch.
    client.register({
      distinct_id: bootstrap.anonymousDistinctID,
      $device_id: bootstrap.anonymousDistinctID,
    });
  }
  if (bootstrap.authID && client.get_distinct_id() !== bootstrap.authID) {
    client.identify(bootstrap.authID);
  }
  client.updateFlags(bootstrap.featureFlags, undefined, { merge: true });
  if (accountChanged && !bootstrap.authID) client.reloadFeatureFlags();
}
